import $ from 'jquery';
import 'slick-carousel';
import isViewport from '../../scripts/util/window/isViewport';
import sendData from '../../scripts/util/request/sendData';
import {lg, sm} from '../../scripts/util/window/isViewport';
import {addFavorite, remined} from '../api/api';

export default class Item {
	constructor() {
		this.selectors = {
			el: '.js-item',
			menu: {
				wrapper: '.js-toggle-wrapper',
				toggle: '.js-toggle'
			},
			slider: {
				wrapper: '.js-sliders',
				preview: '.js-slider-preview',
				recommend: '.js-recommend-slider',
				full: '.js-slider-full'
			},
			favorite: '.js-add-favorite',
			remined: '.js-remind_button',
			button: '.js-item-add',
			form: '.js-item-form',
			message: {
				desktop: '.js-message-desk',
				mobile: '.js-message-mob'
			}
		};

		this.classes = {
			menu: {
				open: 'toggle_state_active'
			},
			message: {
				visible: 'message_state_visible'
			},
			slider: {
				visible: 'item__slider-full_state_visible'
			},
			toggle: {
				active: 'toggle_state_active'
			}
		};
		this.$el = $(this.selectors.el);

	}

	getDom() {
		this.$desktopMessage = $(this.selectors.message.desktop);
		this.$mobileMessage = $(this.selectors.message.mobile);
		this.$button = $(this.selectors.button);
		this.$form = $(this.selectors.form);
		this.$favorite = $(this.selectors.favorite);
		this.$remined = $(this.selectors.remined);
		this.$sliderPreview = $(this.selectors.slider.preview);

		this.$sliderRecommend = $(this.selectors.slider.recommend);
		this.$sliderFull = $(this.selectors.slider.full);
		this.$sliderWrapper = $(this.selectors.slider.wrapper);

		this.navFor = this.$sliderFull.length ? '.js-slider-nav-sync' : '.js-slider-item';

		this.$window = $(window);
	}

	messageOpen() {
		const visible = this.classes.message.visible;
		if (isViewport(lg)) {
			this.$mobileMessage.addClass(visible);
		} else {
			this.$desktopMessage.addClass(visible);
		}
	}

	messageClose() {
		const visible = this.classes.message.visible;
		if (isViewport(lg)) {
			this.$mobileMessage.removeClass(visible);
		} else {
			this.$desktopMessage.removeClass(visible);
		}
	}

	toggleSliders() {
		const $wrapper = this.$sliderWrapper.find(this.selectors.menu.wrapper);
		const $toggle = this.$sliderWrapper.find(this.selectors.menu.toggle);
		const $wrapperNotActive = $toggle.not(`.${this.classes.toggle.active}`).next();
		if (isViewport(sm)) {
			$wrapper.css({
				height: 'auto',
				opacity: '1'
			});
		} else {
			$wrapperNotActive.css({
				height: '0',
				opacity: ''
			});
		}
	}

	onResize() {
		if (this.$sliderWrapper.length) {
			this.toggleSliders();
		}
	}

	onSubmit(e) {
		const $target = $(e.target);
		const send = sendData(e, $target);
		send.then(() => this.messageOpen());
	}

	addToFavorite() {
		addFavorite(this.$el.data('id'));
	}

	reminedClick() {
		remined(this.$el.data('id'));
	}

	sliderInit() {
		this.$sliderPreview.slick({
			vertical: true,
			slidesToShow: 4,
			slidesToScroll: 1,
			infinite: true,
			speed: 0,
			arrows: true,
			focusOnSelect: true,
			verticalSwiping: true,
			asNavFor: this.navFor,
			prevArrow: '<span class="slider-preview__arrow slider-preview__arrow_type_prev"><svg><use xlink:href="/assets/images/icon.svg#icon_arrow"></use></svg></span>',
			nextArrow: '<span class="slider-preview__arrow slider-preview__arrow_type_next"><svg><use xlink:href="/assets/images/icon.svg#icon_arrow"></use></svg></span>',
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						vertical: false,
						verticalSwiping: false
					}
				}
			]
		});

	}

	render() {
		this.getDom();
		this.sliderInit();
		this.$window.on('resize', () => this.onResize());
		this.$form.on('submit', e => this.onSubmit(e));
		this.$window.on('load', () => this.toggleSliders());
		if (this.$el.length) {
			this.$favorite.on('click', () => this.addToFavorite());
			this.$remined .on('click', () => this.reminedClick());
		}
	}
}



/** WEBPACK FOOTER **
 ** ./app/blocks/item/item.js
 **/